import React, { Component } from 'react'; 
import { connect } from 'react-redux';
import classes from './ChildSelection.scss';

import SelectMenu from './ChildSelectionSelect/ChildSelectionSelect';

import ageMapping from '../../../assets/json/ageMapping.json';

import * as hotelActions from '../../../store/actions/index';

class ChildSelection extends Component {

    state = {
        age: 0,
        ageSelectActive: false
    }

    componentDidMount() {
        this.setState({
            age: this.props.childrenAge
        })
    }

    ageSelectHandler = (val) => {
        this.setState({
            age: val,
            ageSelectActive: false 
        }, () => {
            this.props.onSetChildAge(this.state.age, this.props.index, this.props.roomIndex);
        })
    }

    closeSelectMenuHandler = () => this.setState({ ageSelectActive: false })
    toggleClickedHandler = () => this.setState(prevState => { return {ageSelectActive: !prevState.ageSelectActive} })

    render() {
        return (
            <div className={`${classes.Wrapper} u-flex align-items-center u-relative pl-1 pr-1`}>
                <span className={classes.Title}>Age of child {this.props.index}</span>
                <SelectMenu 
                    mapping={ageMapping} 
                    clicked={this.ageSelectHandler} 
                    value={this.state.age} 
                    toggleClicked={this.toggleClickedHandler} 
                    active={this.state.ageSelectActive} 
                    closeSelect={this.closeSelectMenuHandler} 
                    />
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onSetChildAge: (val, id, roomIndex) => dispatch(hotelActions.setChildAge(val, id, roomIndex))
    }
}

export default connect(null, mapDispatchToProps)(ChildSelection);


// WEBPACK FOOTER //
// ./src/components/Travellers/ChildSelection/ChildSelection.js